import styled from "@emotion/styled";

export const Label = styled.label`
  display: block;
  color: var(--mb-color-text-dark);
  font-weight: 700;
  padding-top: 22px;
  padding-bottom: 16px;
  margin-bottom: 8px;
`;
